import axios from "@/libs/api.request";
// 获取列表
export const getCost = (params) => {
  return axios.request({
    url: "/extract/agent/cost",
    params,
    method: "get",
  });
};

export const getConfig = () => {
  return axios.request({
    url: "/common/cost",
    method: "get",
  });
};

export const addCost = (data) => {
  return axios.request({
    url: "/extract/agent/cost",
    method: "post",
    data,
  });
};

export const updateCost = (data) => {
  return axios.request({
    url: `/extract/agent/cost/${data.id}`,
    method: "put",
    data,
  });
};

export const deleteCost = (id) => {
  return axios.request({
    url: `/extract/agent/cost/${id}`,
    method: "delete",
  });
};

// 获取重量参数
export const getWeight = (params) => {
  return axios.request({
    url: `/extract/getAirInfo/${params.id}`,
    method: "get",
    params,
  });
};
// 获取中港单重量信息
export const getPackingInfo = (params) => {
  return axios.request({
    url: `/extract/getPackingInfo/${params.id}`,
    method: "get",
    params,
  });
};

// 获取代理
export const getAirAgent = (params) => {
  return axios.request({
    url: `/extract/airAgent/${params.id}`,
    method: "get",
    params,
  });
};

// 获取计费数值
export const getCostValue = (params) => {
  return axios.request({
    url: `/extract/chargingValue`,
    method: "get",
    params,
  });
};

// 获取科目费用树
export const getSubjectCost = (params) => {
  return axios.request({
    url: `/common/classify`,
    method: "get",
    params,
  });
};

export const batchDel = data => {
  return axios.request({
    url: "/extract/cost/batchDel",
    data,
    method: "post"
  });
};


export const getRule = data => {
  return axios.request({
    url: "/cost/rule/getRule",
    data,
    method: "post"
  });
};

export const batchSave = data => {
  return axios.request({
    url: "/extract/cost/batchSave",
    data,
    method: "post"
  });
};
export const getAgentList = params => {
  return axios.request({
    url: "/common/Transport/agent",
    params,
    method: "get"
  });
};